import { zollBaseURL } from '../../../services/api.service'
import { ZollAPIService } from '../../../services/zollApi.service'
import {
  IPatientDataRequest,
  IPatientDataResponse,
  IPatientSearchRequest,
  IPatientSearchResponse,
} from '../store/patientSearch.types'

const patientSearchUrl = `${zollBaseURL}/api/PatientSearch/search`
const retrievePatientUrl = `${zollBaseURL}/api/PatientSearch/retrieve`

export class PatientSearchService extends ZollAPIService {
  async performSearch(data: IPatientSearchRequest): Promise<IPatientSearchResponse> {
    return this.postWithError(patientSearchUrl, data)
  }

  async getPatientData(data: IPatientDataRequest): Promise<IPatientDataResponse> {
    return this.postWithError(retrievePatientUrl, data)
  }
}
